import { sharedService } from "@/modules/shared/store/services/shared-service";

const getLoanDeletionReasons = sharedService.injectEndpoints({
  endpoints: builder => ({
    getLoanDeletionReasons: builder.query({
      query: () => "parameters/loan-reasons-for-deletion",
      transformResponse: response => response.items,
      providesTags: ["LoanDeletionReasons"],
    }),
  }),
  overrideExisting: false,
});

export const { useGetLoanDeletionReasonsQuery } = getLoanDeletionReasons;

